import { HttpClient } from '@angular/common/http';
import { DrzavaModalUpdateComponent } from './../lookups/drzava/drzava-modal-update.component';
import { CoreRoutingModule } from './core-routing.module';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { YtNgFrameworkModule, ConfigService } from 'yt-ng-framework';
import { HomeComponent } from './home/home.component';
import { LookupsModule } from '../lookups/lookups.module';
import { RobaModalUpdateComponent } from '../lookups/roba/roba-modal-update.component';
import { JedinicaMereModalUpdateComponent } from './../lookups/jedinica-mere/jedinica-mere-modal-update.component';
import { KomitentModalUpdateComponent } from './../lookups/komitent/komitent-modal-update.component';
import { MagacinModalUpdateComponent } from '../lookups/magacin/magacin-modal-update.component';
import { MestoModalUpdateComponent } from './../lookups/mesto/mesto-modal-update.component';
import { OkrugModalUpdateComponent } from '../lookups/okrug/okrug-modal-update.component';
import { OpstinaModalUpdateComponent } from '../lookups/opstina/opstina-modal-update.component';
import { TipKomitentaModalUpdateComponent } from '../lookups/tip-komitenta/tip-komitenta-modal-update.component';
import { VrstaKomitentaModalUpdateComponent } from '../lookups/vrsta-komitenta/vrsta-komitenta-modal-update.component';
import { TarifaModalUpdateComponent } from '../lookups/tarifa/tarifa-modal-update.component';
import { PodVrsteDokumentaModalUpdateComponent } from './../lookups/podvrste-dokumenta/podvrste-dokumenta-modal-update.component';
import { StopaModalUpdateComponent } from '../lookups/stopa/stopa-modal-update.component';
import { RobnaGrupaModalUpdateComponent } from '../lookups/robna-grupa/robna-grupa-modal-update.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import localeSr from '@angular/common/locales/sr-Latn';
// import { NotifierModule, NotifierService } from 'angular-notifier';
// import { SimpleNotificationsModule } from 'angular2-notifications';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FakTrosChartComponent } from './home/charts/fak-tros-chart.component';
import { CompanyRegisterComponent } from './company-register/company-register.component';
import { CompanyRegisterUpdateComponent } from './company-register/company-register-update.component';
// import { ToastrModule } from 'ngx-toastr';

registerLocaleData(localeSr);

@NgModule({
  imports: [
    CoreRoutingModule,
    CommonModule,
    RouterModule,
    // YtNgFrameworkModule.forRoot(),
    YtNgFrameworkModule,
    LookupsModule,
    // NgbModule.forRoot(),
    NgbModule,
    //NotifierModule
    // SimpleNotificationsModule,
    // BrowserAnimationsModule,
    // ToastrModule,
  ],
  declarations: [HomeComponent, FakTrosChartComponent, CompanyRegisterComponent, CompanyRegisterUpdateComponent],
  // entryComponents: [
  //   DrzavaModalUpdateComponent
  //   ,RobaModalUpdateComponent
  //   ,JedinicaMereModalUpdateComponent
  //   ,KomitentModalUpdateComponent
  //   ,MagacinModalUpdateComponent
  //   ,MestoModalUpdateComponent
  //   ,OkrugModalUpdateComponent
  //   ,OpstinaModalUpdateComponent
  //   ,TipKomitentaModalUpdateComponent
  //   ,VrstaKomitentaModalUpdateComponent
  //   ,TarifaModalUpdateComponent
  //   ,PodVrsteDokumentaModalUpdateComponent
  //   ,StopaModalUpdateComponent
  //   ,RobnaGrupaModalUpdateComponent,
  //   CompanyRegisterComponent,
  //   CompanyRegisterUpdateComponent
  // ],
  exports: [
    RouterModule,
    YtNgFrameworkModule
    , TranslateModule 
  ],
  providers: [
    //ConfigService,
    //NotifierService
  ]
})
export class CoreModule { }
